import {apiAuth} from '../../../services/ApiService'
import {createRequest} from '../../../helpers/RequestHelper'

// Salvar Formulario
export function salvarFormulario(data, onSuccess, onError) {
    const path = '/grus/'
    return createRequest({
        api: apiAuth, method: 'POST', path: path, data: data, onSuccess, onError
    });
}

// Editar Formulario
export function editarFormulario(id, data, onSuccess, onError) {
    const path = `/grus/${id}`
    return createRequest({
        api: apiAuth, method: 'PUT', path: path, data: data, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/submits/historico/servicos
export function buscarServicoDeBoleto( onSuccess, onError) {
    const path = `/historico/boleto/servicos`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}


//############# Reducers actions #################

export function addItem(item){
    return{
        type: 'ADD_ITEM_GRU',
        payload: item
    }
}

export function deleteItem(id){
    return{
        type: 'DELETE_ITEM_GRU',
        payload: id
    }
}

export function updateItem(id){
    return{
        type: 'UPDATE_ITEM_GRU',
        payload: id
    }
}

export function updateTitulo(titulo){
    return{
        type: 'UPDATE_TITULO_GRU',
        payload: titulo
    }
}

export function updateDescricao(descricao){
    return{
        type: 'UPDATE_DESCRICAO_GRU',
        payload: descricao
    }
}

export function updateState(newState){
    return{
        type: 'UPDATE_STATE_GRU',
        payload: newState
    }
}

export function resetState(){
    return{
        type: 'RESET_STATE_GRU'
    }
}

export function updateStatusDisponibilidade(statusDisponibilidade){
    return{
        type: 'UPDATE_STATUS_DISPONIBILIDADE_GRU',
        payload: statusDisponibilidade
    }
}

export function upCampo(item){
    return{
        type: 'UP_CAMPO_GRU',
        payload: item
    }
}

export function downCampo(item){
    return{
        type: 'DOWN_CAMPO_GRU',
        payload: item
    }
}

export function updateServicoBoleto(servicoBoleto){
    return{
        type: 'UPDATE_SERVICO_BOLETO_GRU',
        payload: servicoBoleto
    }
}

export function updateIdentificadorGRU(tipo){
    return{
        type: 'UPDATE_IDENTIFICADOR_GRU',
        payload: tipo
    }
}


// WEBPACK FOOTER //
// ./src/view/gru/actions/FormBuilderGRUActions.js